import { TReactRenderTarget } from '@aytm/lib/common/reactCreateRoot'
import { IAction, SurveyMode } from './actions/types'
import { ModuleID } from './modules/types'
import { QuestionID } from './questions/types'
import { ModalID } from './modules/modal/types'
import { IWidgetStyle } from './modules/theme/types'

export const CONFIG_SESSION_ID = 'session'

export enum ISurveyWidgetSessionPropsLayout {
  DEFAULT = 'default',
  COMPACT = 'compact'
}
export enum ISurveyWidgetSessionPropsTheme {
  DEFAULT = 'default',
  LIGHT = 'light'
}
export interface ISurveyWidgetSessionProps {
  layout?: ISurveyWidgetSessionPropsLayout
  theme?: ISurveyWidgetSessionPropsTheme
  /** Fill the host's bounded height: the question body scrolls, progress bar and navigation stay pinned. */
  fill?: boolean
  custom?: {
    [key: string]: unknown
  }
}

export interface ISurveyWidget {
  action(action: IAction): ISurveyWidget
  loadAction(
    url: string,
    payloadOrTransformLoadAction: Record<string, unknown> | ((loadAction: IAction) => IAction),
    apply?: boolean
  ): Promise<IAction>
  loadTarget(
    target: QuestionID,
    initURL: string,
    mode?: SurveyMode,
    payload?: Record<string, unknown>,
    verify?: boolean
  ): Promise<[IAction, IAction]>
  loadLocale(locale: string, target: QuestionID, initURL: string, mode?: SurveyMode): Promise<IAction>
  loader({ mode }: { mode?: SurveyMode }): ISurveyWidget
  config(moduleID: ModuleID | typeof CONFIG_SESSION_ID, props: unknown): ISurveyWidget
  render(target: TReactRenderTarget | ModalID): ISurveyWidget
  unmount(target?: TReactRenderTarget): void
  get currentAction(): IAction
  applyCustomStyle(style: IWidgetStyle): ISurveyWidget
}
